import { render } from "./remote_user_resolver.vue?vue&type=template&id=198402c4"
import script from "./remote_user_resolver.js?vue&type=script&lang=js&external"
export * from "./remote_user_resolver.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__